import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/douyin-mini-program"
    path="business/services/douyin-mini-program"
    element={<AsyncPage />}
  />,
];
